document.addEventListener('wpcf7mailsent', (event) => {
	location.href = window.dfCf7Settings?.thanksUrl || '/contact-thanks/';
}, false);
